import Text from '@cartwhl/ui/base/Text';
import FileIcon from '@cartwhl/ui/icons/FileIcon';

import BatchReferenceEmptyDropzone from '../../shared/BatchReferenceEmptyDropzone';

export const MASCOT_REFERENCE_DROPZONE_HEIGHT_PX = 150;

export interface MascotReferenceDropzoneEmptyProps {
  onOpenLibrary: () => void;
}

export default function MascotReferenceDropzoneEmpty({
  onOpenLibrary,
}: MascotReferenceDropzoneEmptyProps) {
  return (
    <BatchReferenceEmptyDropzone
      onOpenLibrary={onOpenLibrary}
      dropHint={
        <div className="flex items-center gap-1">
          <FileIcon className="text-blue shrink-0" />
          <Text variant="studio/body/medium/sm" className="text-gray-60">
            drag and drop here
          </Text>
        </div>
      }
    />
  );
}
